module.exports = {"img":{"map":"Carte2016-romains-en.png"},"meta":{"F":"@:html.soft","DIo":"<a href=\"@:link.DIo\">@:meta.dioname</a>"}};